<template>
  <div class="cabin-type-list">
    <div class="cabin-type-item" v-for="(cabinItem, cabinIndex) in flightItem.cabinClassGroup" :key="cabinIndex">
      <div
        class="choose-cabin"
        :class="[
          activeCabinIndex == cabinIndex ? 'active-cabin' : '',
        ]"
        @click="chooseCurrentCabin(cabinIndex)"
      >
        <div style="padding: 20px 0;">{{ cabinItem.cabinClassName }}</div>
        <div>¥<span style="font-size: 30px">{{ cabinItem.cabinClassLowAmount }}</span>起</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: "CabinType",
  props: {
    flightItem: {
      type: Object,
      default: () => ({})
    },
    flightIndex: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      activeCabinIndex: 0
    }
  },

  methods: {
    chooseCurrentCabin(index) {
      this.activeCabinIndex = index;
      this.$emit("chooseCurrentCabin", this.flightIndex, this.activeCabinIndex);
    },
  }

};
</script>

<style lang="less" scoped>
  .cabin-type-list {
    display: flex;
    height: 100%;
  }
.cabin-type-item {
  width: 130px;
  // line-height: 65px;
  color: #4d4e4e;
  text-align: center;
  .active-cabin {
    background-color: #d70039;
    border-left-color: #d31a1a;
    color: #fff !important;
  }
  .first-cabin {
    background-color: #d3b798;
    border-left-color: #d3b798;
  }
  .choose-cabin {
    height: 100%;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .active-cabin::after {
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    z-index: 100;
    top: 100%;
    right: 0;
    border-width: 30px 65px 0;
    border-style: solid;
    border-color: #d70039 transparent transparent;
  }
}
</style>
